import type {LoaderFunctionArgs} from 'react-router';
import {redirect} from 'react-router';

import {getInstance} from '../../../../helpers/axios-helper';
import {getEnvironment, isLoggedIn} from '../../../../helpers/session';
import type {Printer} from '../../../../types/printer';

export type TerminalLoaderData = {
    /** not awaited: the terminal shows its loading screen in the layout until they are there */
    printers: Promise<Printer[]>;
};

/** The box label printers to pick a shipping station from, fetched while the terminal's code loads. */
export const terminalLoader = ({request}: LoaderFunctionArgs): TerminalLoaderData | Response => {
    // the layout's loader sends a guest to the login page: nothing to fetch (the API client would redirect as well)
    if (!isLoggedIn()) {
        return redirect('/login');
    }

    const printers = getInstance(getEnvironment())
        .get<Printer[]>('/api/v3/printers?type=boxlabel', {signal: request.signal})
        .then(response => response.data);

    // the terminal handles a failure; when it was left before the printers came, nobody does: not an unhandled rejection
    printers.catch(() => undefined);

    return {printers};
};
